var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddToSalesforceCampaign = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#563BCE",
    d: "M21.75 12c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25s9.75 4.365 9.75 9.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    d: "M17.25 15.938a.263.263 0 0 0-.262-.263h-.6v-.6a.263.263 0 0 0-.526 0v.6h-.6a.26.26 0 0 0-.262.26v.002c0 .146.118.263.262.263h.6v.6c0 .144.117.261.26.262h.003a.263.263 0 0 0 .262-.262v-.6h.6a.263.263 0 0 0 .263-.262"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    fillRule: "evenodd",
    d: "M18.375 15.938a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0m-2.25 1.687a1.687 1.687 0 1 0 0-3.375 1.687 1.687 0 0 0 0 3.375",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    d: "m10.795 12.345.603.36.602.351.581.345a.439.439 0 0 1-.445.756L12 14.075l-1.047-.615-.02-.012-.018-.013-.351-.207H9.75V16.8a.45.45 0 1 1-.9 0v-3.572H7.44c-.796 0-1.44-.659-1.44-1.47V9.551c0-.813.644-1.47 1.44-1.47h3.872L14.67 6.1c.48-.283 1.079.07 1.079.636v5.583a.431.431 0 0 1-.863 0V6.99l-3.344 1.972H7.44a.58.58 0 0 0-.576.589v2.205c0 .325.258.588.576.588h3.356Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddToSalesforceCampaign);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add-to-salesforce-campaign.da2483c4.svg";